<button class="ai-chat-button" (click)="openAiChat()">
  <span class="ai-chat-icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" viewBox="0 0 23 24" fill="none">
      <path
        d="M7.62461 15.4938L6.77461 17.6938H4.34961L8.27461 7.96875H11.2996L15.4246 17.6938H12.8746L11.9746 15.4938H7.64961H7.62461ZM11.2996 13.5938C10.3996 11.3688 9.94961 10.2188 9.72461 9.49375C9.49961 10.2188 8.99961 11.6938 8.24961 13.5938H11.2996Z"
        fill="#E1E31C"
      />
      <path d="M18.3245 7.96875H15.9995V17.6938H18.3245V7.96875Z" fill="#E1E31C" />
      <path
        d="M20.175 23.6937H2.475C1.125 23.6937 0 22.6187 0 21.3187V3.7937C0 2.4687 1.1 1.4187 2.475 1.4187H11.225C11.75 1.4187 12.175 1.8437 12.175 2.3437C12.175 2.8437 11.75 3.2687 11.225 3.2687H2.475C2.175 3.2687 1.925 3.4937 1.925 3.7937V21.2937C1.925 21.5937 2.175 21.8187 2.475 21.8187H20.175C20.475 21.8187 20.725 21.5937 20.725 21.2937V5.2187C20.725 4.6937 21.15 4.2937 21.675 4.2937C22.2 4.2937 22.625 4.7187 22.625 5.2187V21.3187C22.625 22.6437 21.525 23.6937 20.15 23.6937H20.175Z"
        fill="white"
      />
      <path
        d="M18.6247 4.01865H18.6497C19.4997 3.16865 19.4997 1.81865 18.6747 0.993653L18.6247 0.943652C17.7997 0.0936524 16.4497 0.0936524 15.5997 0.943652H15.5747C14.7497 1.81865 14.7747 3.14365 15.5997 3.96865L15.6497 4.01865C16.4747 4.81865 17.7747 4.81865 18.5997 4.01865H18.6247Z"
        fill="white"
      />
    </svg>
  </span>
  <span class="ai-chat-label">Chat</span>
</button>
